<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-8 login-bg vh-100" :style="'background-image: url('+bg+')'">
        <img :src="logo" class="logo m-5" />
      </div>
      <div class="col vh-100 d-flex flex-wrap align-items-center justify-content-center">
        <div class="text-secondary w-80">
          <h2 class="fw-bold">¡Bienvenid@ a Moby<span class="text-info">Docs</span>!</h2>
          <h5>Por favor inicia sesión</h5>
          <div v-if="error.length > 0" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{error}}
            <button type="button" class="btn-close" @click="error=''"></button>
          </div>
          <div class="form-floating text-dark">
            <input v-model="user.email" type="email" class="form-control border-secondary" id="floatingInput">
            <label for="floatingInput">Email</label>
          </div>
          <div class="form-floating text-dark input-group my-3">
            <input v-model="user.password" :type="(showPassword ? 'text' : 'password')" class="form-control" id="floatingPassword" placeholder="Password">
            <label for="floatingPassword">Password</label>
              <button class="btn btn-light" type="button" @click="showPassword = !showPassword"><font-awesome-icon :icon="['fal', (showPassword ? 'eye-slash' : 'eye')]" /></button>
          </div>
          <div class="mb-3 form-check">
            <input v-model="remember" type="checkbox" class="form-check-input" id="rememberMe">
            <label class="form-check-label" for="rememberMe">Recordarme</label>
          </div>
          <div class="d-grid gap-2">
            <button @click="login" type="button" class="btn btn-primary text-white">Iniciar sesión</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export	default	{
    name:	"login",
    data(){
      return {
        showPassword: false,
        logo: require('@/assets/images/general/logo-mobydocs.svg'),
        bg: require('@/assets/images/login/bg.png'),
        user: {email: null, password: null},
        remember: true,
        error: ''
      }
    },
    methods: {
      login(){
        let	app = this;
        this.error = "";
        this.$auth.login({
          data: app.user,
          rememberMe: this.remember,
          redirect: {name: 'index'},
          fetchUser: true,
        }).then(null, () => {
          app.error = "Usuario y/o contraseña incorrecto(s)"
        })
      },
    }
  }
</script>
<style>
</style>
